import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Flex,
  Text,
  Select,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  useDisclosure,
  Badge,
  Stack,
  Input,
  IconButton,
  Icon,
  Image,
  Avatar,
} from "@chakra-ui/react";
import { FaEdit, FaTrash, FaClipboardList } from "react-icons/fa"; // Import the icons from react-icons
import { FaUserTie, FaBook } from "react-icons/fa";

import axios from "axios";
import "../Student/student.css";
import { FaPlus, FaSync, FaPrint } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { ArrowBackIcon } from "@chakra-ui/icons";
import { Link } from "react-router-dom";
import Print_pdf_subject from "./Print_pdf_subject";
import Edit_modal_subject from "./Edit_modal_subject";
import { BASE_URL } from "../../Globalapi/Globalapi";

const AssigningSubject = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false); // <-- Add loading state
  const [error, setError] = useState(null); // <-- Add error state
  const [staffList, setStaffList] = useState([]);
  const [subjectList, setSubjectList] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [assignments, setAssignments] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [editingAssignmentId, setEditingAssignmentId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortOption, setSortOption] = useState("");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [showPrintPdf, setShowPrintPdf] = useState(false);
  // const [assignments, setassignments] = useState([]);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const printComponentRef = useRef(); // Reference to Print_pdf_class_list component
  const [selectedSubjectFilter, setSelectedSubjectFilter] = useState("");

  useEffect(() => {
    // Fetch staff list
    const school_id = sessionStorage.getItem("school_id"); // If JWT is needed

    axios
      .get(`${BASE_URL}/admin/staff/staff_list.php?school_id=${school_id}`)
      .then((response) => setStaffList(response.data.data || []))
      .catch((error) => console.error("Error fetching staff:", error));

    // Fetch subject list
    axios
      .get(`${BASE_URL}/admin/subject/list_subject.php`)
      .then((response) => setSubjectList(response.data.data || []))
      .catch((error) => console.error("Error fetching subjects:", error));

    // Fetch all assigned subjects
    axios
      .get(`${BASE_URL}/admin/subject/list_all_teacher_subject_to_admin.php`)
      .then((response) => {
        console.log("ash", response.data.data); // Log the data received
        setAssignments(response.data.data || []);
      })
      .catch((error) => console.error("Error fetching assignments:", error));
  }, []);

  const handleAssign = () => {
    const apiUrl = isEditing
      ? `${BASE_URL}/admin/subject/edit_subject_to_teacher.php`
      : `${BASE_URL}/admin/subject/create_subject_to_teacher.php`;

    const payload = {
      staff_id: selectedStaff,
      subject_id: selectedSubject,
      ...(isEditing && { teachers_subject_id: editingAssignmentId }),
      pass: sessionStorage.getItem("user_id"),
    };

    axios({
      method: isEditing ? "put" : "post",
      url: apiUrl,
      data: payload,
    })
      .then((response) => {
        // Optimistically update the assignments state
        const updatedAssignments = isEditing
          ? assignments.map((assignment) =>
              assignment.id === editingAssignmentId
                ? {
                    ...assignment,
                    staff_id: selectedStaff,
                    subject_id: selectedSubject,
                  }
                : assignment
            )
          : [
              ...assignments,
              {
                id: response.data.id,
                staff_id: selectedStaff,
                subject_id: selectedSubject,
                status: "Active",
              },
            ];

        setAssignments(updatedAssignments);

        // Optionally refetch assignments to ensure data is synced with the backend
        axios
          .get(
            `${BASE_URL}/admin/subject/list_all_teacher_subject_to_admin.php`
          )
          .then((response) => setAssignments(response.data.data || []))
          .catch((error) =>
            console.error("Error fetching assignments:", error)
          );

        onClose();
        setIsEditing(false);
        setEditingAssignmentId(null);
      })
      .catch((error) => console.error("Error handling assignment:", error));
  };

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedAssignment, setSelectedAssignment] = useState(null); // Optional, if you want to pass data to the modal

  const handleEdit = (assignment) => {
    console.log("Assignment being edited:", assignment); // Check if staff_id is there
    setSelectedAssignment(assignment); // Set the data to be passed into the modal
    setIsEditModalOpen(true); // Open the modal
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const jwt = sessionStorage.getItem("jwt");
        const school_id = sessionStorage.getItem("school_id"); // If JWT is needed

        // Fetch staff list
        const staffResponse = await axios.get(
          `${BASE_URL}/admin/staff/staff_list.php?school_id=${school_id}`,
          {
            headers: {
              Authorization: `Bearer ${jwt}`,
            },
          }
        );
        setStaffList(staffResponse.data.data || []);

        // Fetch subject list
        const subjectResponse = await axios.get(
          `${BASE_URL}/admin/subject/list_subject.php`,
          {
            headers: {
              Authorization: `Bearer ${jwt}`,
            },
          }
        );
        setSubjectList(subjectResponse.data.data || []);

        // Fetch all assigned subjects
        const assignmentResponse = await axios.get(
          `${BASE_URL}/admin/subject/list_all_teacher_subject_to_admin.php`,
          {
            headers: {
              Authorization: `Bearer ${jwt}`,
            },
          }
        );
        setAssignments(assignmentResponse.data.data || []);
        setIsDataLoaded(true); // Mark data as loaded
      } catch (err) {
        console.error("Error fetching data:", err);
        setError("Error fetching data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleDelete = (id) => {
    console.log("delete assign teacher id", id);
    axios
      .delete(`${BASE_URL}/admin/subject/delete_subject_to_teacher.php`, {
        data: { teachers_subject_id: id },
      })
      .then(() => {
        // Refetch assignments
        axios
          .get(
            `${BASE_URL}/admin/subject/list_all_teacher_subject_to_admin.php`
          )
          .then((response) => {
            console.log("Assignments response after delete:", response); // full response
            console.log("Assignments data only:", response.data); // just data
            setAssignments(response.data.data || []);
          })
          .catch((error) =>
            console.error("Error fetching assignments after deletion:", error)
          );
      })
      .catch((error) => console.error("Error deleting assignment:", error));
  };

  const filteredAssignments = assignments.filter((assignment) => {
    const matchesSearch = assignment.staff_name
      ?.toLowerCase()
      .includes(searchTerm.toLowerCase());

    const matchesSubject =
      !selectedSubjectFilter ||
      assignment.staff_subject?.includes(selectedSubjectFilter);

    return matchesSearch && matchesSubject;
  });

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentData = filteredAssignments.slice(
    indexOfFirstRow,
    indexOfLastRow
  );

  const totalPages = Math.ceil(filteredAssignments.length / rowsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  const handlePrint = () => {
    // Only trigger print if data is fully loaded
    if (isDataLoaded && printComponentRef.current) {
      printComponentRef.current.handlePrint();
    } else {
      console.log("Data is still loading...");
    }
  };

  return (
    <Box borderRadius="md" overflowX="auto" bg="white">
      <div style={{ backgroundColor: "#FBFBFD", height: "100vh" }}>
        <div className="teacher-list-container">
          <div
            className="header"
            style={{ display: "flex", alignItems: "center" }}
          >
            <h1 style={{ fontSize: "20px", margin: 0 }}>
              Assign Subject To Teacher{" "}
            </h1>
            <div className="action-buttons" style={{ marginLeft: "auto" }}>
              <div className="export-dropdown">
                <Button
                  className="export-button"
                  display={{ base: "none", md: "flex" }}
                  backgroundColor="white"
                  fontSize="11px"
                  boxShadow="md"
                  onClick={handlePrint} // Attach the print handler here
                >
                  <FaPrint color="#515B73" />
                  Print PDF
                </Button>
              </div>

              <Button colorScheme="teal" leftIcon={<FaPlus />} onClick={onOpen}>
                <Box display={{ base: "none", md: "block" }}>
                  {isEditing ? "Edit Assignment" : "Assign Subject"}
                </Box>
              </Button>
            </div>
          </div>

          <div className="breadcrumb">
            <Link
              to="/admin"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <span>Dashboard</span>
            </Link>{" "}
            / <span> Teachers</span> / <span> Assign</span>
          </div>
        </div>
        <Box p={6}>
          <Flex
            justify="space-between"
            align="center"
            mb={1}
            p={3}
            className="sb"
            // STACK VERTICALLY on mobile, go to ROW on medium/desktop
            direction={{ base: "column", md: "row" }}
            // Add vertical space between stacked items on mobile
            gap={{ base: 4, md: 0 }}
          >
            {/* Left Side - Rows Per Page */}
            <Flex align="center">
              <Text mr={2}>Rows Per Page</Text>
              <Select
                value={rowsPerPage}
                width="100px"
                onChange={(e) => setRowsPerPage(Number(e.target.value))}
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
              </Select>
            </Flex>

            <Flex
              align="center"
              gap={4}
              direction={{ base: "column", md: "row" }} // Ensure these inner items stack, too
              width={{ base: "100%", md: "auto" }} // Make the container full width on mobile
            >
              <FormControl
                id="subjectFilter"
                width={{ base: "100%", md: "200px" }} // 100% width on mobile 👈 FIX 1
              >
                <Select
                  placeholder="Filter subject"
                  value={selectedSubjectFilter}
                  onChange={(e) => setSelectedSubjectFilter(e.target.value)}
                >
                  {subjectList.map((subject) => (
                    <option key={subject.id} value={subject.subject}>
                      {subject.subject}
                    </option>
                  ))}
                </Select>
              </FormControl>
              <Input
                width={{ base: "100%", md: "200px" }} // 100% width on mobile 👈 FIX 2
                type="text"
                placeholder="Search by Name"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </Flex>
          </Flex>
          {/* <Flex
            justify="space-between"
            align="center"
            mb={1}
            p={3}
            className="sb"
            direction={{ base: "column", md: "row" }} // Stack on mobile, row on medium and larger screens
          >
            <Flex align="center">
              <Text mr={2}>Rows Per Page</Text>
              <Select
                value={rowsPerPage}
                width="100px"
                onChange={(e) => setRowsPerPage(Number(e.target.value))}
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
              </Select>
            </Flex>

            <Flex align="center" gap={4}>
              <FormControl id="subjectFilter" width="200px">
                <Select
                  placeholder="Filter subject"
                  value={selectedSubjectFilter}
                  onChange={(e) => setSelectedSubjectFilter(e.target.value)}
                >
                  {subjectList.map((subject) => (
                    <option key={subject.id} value={subject.subject}>
                      {subject.subject}
                    </option>
                  ))}
                </Select>
              </FormControl>
              <Input
                width="200px"
                type="text"
                placeholder="Search by Name"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </Flex>
          </Flex> */}

          <div style={{ overflowX: "auto" }}>
            {currentData.length === 0 ? (
              <Flex justify="center" align="center" minHeight="200px">
                <Text color="gray.500">No assignments found</Text>
              </Flex>
            ) : (
              <Table
                sx={{
                  "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
                }}
                size="md"
              >
                <Thead bg="#F2F4F8">
                  <Tr>
                    {/* <Th>Image</Th> */}
                    <Th>Staff Name</Th>
                    <Th>Subject</Th>
                    <Th>Status</Th>
                    <Th isNumeric style={{ textAlign: "center" }}>
                      Actions
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {currentData.map((assignment, index) => {
                    const staffName = assignment.staff_name || "Unknown";

                    // Split the staff_subject into an array of subjects
                    const subjects = assignment.staff_subject.split(",");

                    return (
                      <Tr key={index}>
                        <Td>
                          <Link
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                            }}
                            to={`/teachers/detail/${assignment.staff_user_id}`}
                          >
                            <Avatar
                              src={assignment.image_url}
                              alt={assignment.staff_name}
                              name={assignment.staff_name}
                              size="sm"
                              objectFit="cover"
                              onError={(e) => {
                                e.target.src =
                                  "https://t4.ftcdn.net/jpg/02/29/75/83/360_F_229758328_7x8jwCwjtBMmC6rgFzLFhZoEpLobB6L8.jpg";
                              }}
                            />
                            {staffName}
                          </Link>
                        </Td>
                        <Td>
                          {/* Join the subjects array into a single string to display them */}
                          {subjects.join(", ")}
                        </Td>
                        <Td py="12px" px="20px" textAlign="left">
                          <Badge
                            colorScheme={
                              assignment.status === "Active" ? "green" : "green"
                            }
                            borderRadius="full"
                            px={4}
                            py={1}
                            fontSize="11px"
                          >
                            {assignment.status === "Active"
                              ? "Active"
                              : "Active"}
                          </Badge>
                        </Td>
                        <Td isNumeric style={{ textAlign: "center" }}>
                          <Box display="flex" alignItems="center">
                            <IconButton
                              icon={<FaEdit />}
                              colorScheme="blue"
                              onClick={() => handleEdit(assignment)}
                              size="sm" // Keep the button small
                            />

                            <IconButton
                              icon={<FaTrash />}
                              colorScheme="red"
                              onClick={() =>
                                handleDelete(assignment.staff_user_id)
                              }
                              size="sm" // Keep the button small
                              ml={2} // Maintain the spacing between the buttons
                            />
                          </Box>
                        </Td>
                      </Tr>
                    );
                  })}
                </Tbody>
              </Table>
            )}
          </div>

          <Flex
            justify="end"
            borderTopWidth="1px"
            className="
          sb2"
            p={3}
          >
            <Button
              onClick={() => handlePageChange(currentPage - 1)}
              isDisabled={currentPage === 1}
            >
              Prev
            </Button>
            <Stack direction="row" mx={2}>
              {currentPage > 1 && (
                <>
                  <Button onClick={() => handlePageChange(1)}>1</Button>
                  {currentPage > 2 && <Text>...</Text>}
                </>
              )}
              <Button backgroundColor="teal" color="white">
                {currentPage}
              </Button>
              {currentPage < totalPages - 1 && (
                <>
                  <Text>...</Text>
                  <Button onClick={() => handlePageChange(totalPages)}>
                    {totalPages}
                  </Button>
                </>
              )}
            </Stack>
            <Button
              onClick={() => handlePageChange(currentPage + 1)}
              isDisabled={currentPage === totalPages}
            >
              Next
            </Button>
          </Flex>
        </Box>

        <Modal
          isCentered
          isOpen={isOpen}
          onClose={onClose}
          size="lg"
          motionPreset="slideInBottom"
        >
          <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
          <ModalContent
            borderRadius="lg"
            boxShadow="xl"
            bg="linear-gradient(135deg, #e0f7f7, #f0ffff)"
            color="gray.700"
            p={6}
            maxW="700px"
            maxH="550px"
            overflowY="auto"
          >
            <ModalHeader
              fontSize="xl"
              fontWeight="bold"
              textAlign="center"
              color="teal.600"
            >
              <Icon as={FaClipboardList} boxSize={5} mr={2} />
              {isEditing ? "Edit Assignment" : "Assign Subject"}
            </ModalHeader>

            <ModalCloseButton />
            <ModalBody>
              <FormControl id="staff">
                <FormLabel>
                  {" "}
                  <Icon
                    as={FaUserTie}
                    color="teal.500"
                    style={{ marginRight: "8px" }}
                  />
                  Staff
                </FormLabel>
                <Select
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  value={selectedStaff}
                  onChange={(e) => setSelectedStaff(e.target.value)}
                >
                  <option value="">Select staff</option>
                  {staffList.map((staff) => (
                    <option key={staff.id} value={staff.id}>
                      {staff.name}
                    </option>
                  ))}
                </Select>
              </FormControl>
              <FormControl id="subject" mt={4}>
                <FormLabel>
                  {" "}
                  <Icon
                    as={FaBook}
                    color="teal.500"
                    style={{ marginRight: "8px" }}
                  />
                  Subject
                </FormLabel>
                <Select
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  value={selectedSubject}
                  onChange={(e) => setSelectedSubject(e.target.value)}
                >
                  <option value="">Select subject</option>
                  {subjectList.map((subject) => (
                    <option key={subject.id} value={subject.id}>
                      {subject.subject}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </ModalBody>
            <ModalFooter>
              <Button
                bgGradient="linear(to-r, teal.400, teal.600)"
                color="white"
                _hover={{ bgGradient: "linear(to-r, teal.500, teal.700)" }}
                mr={3}
                onClick={handleAssign}
              >
                {isEditing ? "Save Changes" : "Assign"}
              </Button>
              {/* <Button onClick={onClose}>Cancel</Button> */}
            </ModalFooter>
          </ModalContent>
        </Modal>
        <div style={{ display: "none" }}>
          <Print_pdf_subject
            ref={printComponentRef}
            assignments={assignments}
          />
        </div>
      </div>

      {isEditModalOpen && selectedAssignment && (
        <Edit_modal_subject
          staffId={selectedAssignment.staffId} // Make sure selectedAssignment is set
          staffName={selectedAssignment.staff_name}
          onClose={() => setIsEditModalOpen(false)} // Close modal
        />
      )}
    </Box>
  );
};

export default AssigningSubject;
